// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { FirmwareVersionMessage, FirmwareVersionMessageT } from './firmware-version-message';


export enum EscalatorControllerInfoContent {
  NONE = 0,
  FirmwareVersionMessage = 1
}

export function unionToEscalatorControllerInfoContent(
  type: EscalatorControllerInfoContent,
  accessor: (obj:FirmwareVersionMessage) => FirmwareVersionMessage|null
): FirmwareVersionMessage|null {
  switch(EscalatorControllerInfoContent[type]) {
    case 'NONE': return null; 
    case 'FirmwareVersionMessage': return accessor(new FirmwareVersionMessage())! as FirmwareVersionMessage;
    default: return null;
  }
}

export function unionListToEscalatorControllerInfoContent(
  type: EscalatorControllerInfoContent, 
  accessor: (index: number, obj:FirmwareVersionMessage) => FirmwareVersionMessage|null, 
  index: number
): FirmwareVersionMessage|null {
  switch(EscalatorControllerInfoContent[type]) {
    case 'NONE': return null; 
    case 'FirmwareVersionMessage': return accessor(index, new FirmwareVersionMessage())! as FirmwareVersionMessage;
    default: return null;
  }
}
